import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/esm/Button';
import '../../../styles/GlobalStyles.css'
import '../BaseModal.css'
import './AddEditHealthCategoryModal.css'
import { TextInputField } from '../../atoms/TextInputField';
import BeatLoader from "react-spinners/BeatLoader";
import { requiredText, somethingWrongText } from '../../../constants/Variables';
import { toast } from 'react-toastify';
import { addHealthCategory, updateHealthCategory } from '../../../services/common/CommonServices';



export const AddEditHealthCategoryModal = ({
    show,
    onHide,
    triggered,
    editableData,
    setEditableHeathCategory,
}) => {
    // console.log(testimonialItemData, "its data")
    let size = Object.keys(editableData).length
    // console.log(size, 'its size')

    const [values, setValues] = useState({
        code: editableData?.categoryCode || "",
        category: editableData?.name || ""
    })

    const [errorMessageObject, setErrorMessageObject] = useState({
        codeError: '',
        categoryError: '',
    })
    const [loading, setLoading] = useState(false);

    //helpers****************************************

    const hanldeInputValue = (key, e) => {
        setValues({ ...values, [key]: e })
    }

    const handleFocus = (key, e) => {
        key === "code" ? setErrorMessageObject({ ...errorMessageObject, codeError: '' }) : setErrorMessageObject({ ...errorMessageObject, categoryError: '' })
    }

    const handleBlur = () => {
    }

    const handleHide = () => {
        setEditableHeathCategory();
        onHide();
    }

    const validation = () => {
        if (values.code?.trim() === "") {
            setErrorMessageObject({ ...errorMessageObject, codeError: requiredText })
            return false;
        }
        else if (values.category?.trim() === "") {
            setErrorMessageObject({ ...errorMessageObject, categoryError: requiredText })
            return false;
        }
        else {
            return true;
        }
    }

    const handleSubmit = () => {
        if (validation()) {
            setLoading(true)
            const requestObject = {
                cate_code: values.code,
                cate_name: values.category,
            }
            const addCategoryResponse = size !== 0 ? updateHealthCategory(requestObject) : addHealthCategory(requestObject);
            addCategoryResponse.then((data) => {
                setLoading(false)
                // console.log(data, 'its response after testimonial')
                if (data?.status) {
                    triggered();
                    toast(data?.message, { type: 'success' });
                    setValues({
                        cate_code: '',
                        cate_name: '',
                    })
                    handleHide();
                }
                else {
                    toast(data?.message, { type: 'error' });
                }
            }).catch((error) => {
                setLoading(false)
                console.log(error, "error inthe submit testimonials")
                toast(somethingWrongText, { type: 'error' });
            })
        }
    }


    return (
        <Modal show={show} onHide={handleHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton className='modal-header'>
                <Modal.Title id="contained-modal-title-vcenter justify-content-center">
                    {size !== 0 ? "Edit" : "Add"}{" "} Health Category
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <TextInputField
                        // label="Title/Reference"
                        fieldType="text"
                        idfor="exampleInputName"
                        placeholder="Category code*"
                        error={errorMessageObject.codeError}
                        focusHandler={handleFocus}
                        blurHandler={handleBlur}
                        handleChange={hanldeInputValue}
                        keyName="code"
                        value={values.code}
                        style="modal-input-style"
                        disabled={size !== 0 ? true : false}
                    />
                    <TextInputField
                        // label="Title/Reference"
                        fieldType="text"
                        idfor="exampleInputName"
                        placeholder="Category name*"
                        error={errorMessageObject.categoryError}
                        focusHandler={handleFocus}
                        blurHandler={handleBlur}
                        handleChange={hanldeInputValue}
                        keyName="category"
                        value={values.category}
                        style="modal-input-style"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className='modal-footer'>
                <Button
                    disabled={loading}
                    onClick={() => handleSubmit()}
                >
                    {loading ?
                        <BeatLoader color="#7525E8" /> :
                        size !== 0 ? "Update" : "Submit"
                    }</Button>
            </Modal.Footer>
        </Modal>
    )
}